import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice'
import licenseReducer from "./licenseSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    license: licenseReducer,
  },
});

export default store;
